/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planning_Vakanties_Vervallen_WeekInputs */

const nl_planning_vakanties_vervallen_week = /** @type {(inputs: Planning_Vakanties_Vervallen_WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`In die week vervalt 1 gymles uit het rooster.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`In die week vervallen ${i?.count} gymlessen uit het rooster.`);
	return /** @type {LocalizedString} */ ("planning.vakanties.vervallen_week");
};

/**

* @param {Planning_Vakanties_Vervallen_WeekInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_vervallen_week = /** @type {((inputs: Planning_Vakanties_Vervallen_WeekInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Vervallen_WeekInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_vervallen_week(inputs)
});
export { planning_vakanties_vervallen_week as "planning.vakanties.vervallen_week" }